import React from 'react';
import {
  Text,
  View,
} from 'react-native';
import { Entypo } from '@expo/vector-icons';
import { getMediumFont } from '../../../../utils/Utils';
//= ========================================================================

const ShareIconNearBtn = ({
  globJSON, simPlatform, inputText,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyle = {
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: '7%',
      backgroundColor: colors.app_background_color,
    },
    btnStyle: {
      width: 156,
      height: 29,
      backgroundColor: colors.primary_cta_color,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 15,
      justifyContent: 'center',
      textAlign: 'center',
    },
    txtStyle: {
      fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
      fontSize: 10.4,
      color: colors.cta_font_color,
    },
    iconShareStyle: {
      fontSize: 16,
      color: colors.primary_font_color,
    },
  };
  return (
    <View
      style={myStyle.container}
    >
      <View style={myStyle.btnStyle}>
        <Text style={myStyle.txtStyle}>
          {inputText}
        </Text>
      </View>
      <Entypo
        name="share"
        style={myStyle.iconShareStyle}
      />
    </View>
  );
};
export default ShareIconNearBtn;
